<div class="fixed inset-0 z-[60] flex items-center justify-center p-4">
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" (click)="closeModal()"></div>

    <div
        class="relative bg-white dark:bg-slate-900 rounded-3xl shadow-xl w-full max-w-lg overflow-hidden animate-fade-in-up border border-transparent dark:border-slate-800">

        <!-- Header -->
        <div
            class="bg-white dark:bg-slate-900 p-6 border-b border-gray-100 dark:border-slate-800 flex justify-between items-center">
            <div>
                <h3 class="text-lg font-bold text-gray-800 dark:text-white">เพิ่มสมาชิกไลน์</h3>
                <p class="text-sm text-gray-500 dark:text-slate-400">เพิ่มข้อมูลสมาชิกไลน์สำหรับ {{ customer?.name }}
                </p>
            </div>
            <button (click)="closeModal()"
                class="text-gray-400 dark:text-slate-500 hover:text-gray-600 dark:hover:text-slate-300 transition">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6 space-y-4">

            <!-- Search Mode -->
            <div *ngIf="lineChoose.length === 0">
                <label class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">Line ID | เบอร์โทรศัพท์
                    <span class="text-red-500">*</span></label>
                <div class="flex gap-2">
                    <input type="text" [(ngModel)]="keyword" (keyup.enter)="saveData()" maxlength="10"
                        placeholder="Line ID หรือ 08xxxxxxxx"
                        class="w-full px-4 py-2 border border-gray-300 dark:border-slate-600 dark:bg-slate-900 rounded-lg focus:ring-2 focus:ring-green-100 dark:focus:ring-green-900/40 focus:border-green-400 dark:focus:border-green-500 outline-none transition font-mono dark:text-white">
                    <button (click)="saveData()" [disabled]="isSearching"
                        class="px-4 py-2 bg-emerald-500 shadow-md text-white rounded-xl hover:bg-green-700 disabled:bg-gray-300 dark:disabled:bg-slate-700 disabled:cursor-not-allowed transition hidden sm:inline-flex">
                        <span *ngIf="!isSearching">ค้นหา</span>
                        <span *ngIf="isSearching">...</span>
                    </button>
                    <!-- Mobile Search button -->
                    <button (click)="saveData()" [disabled]="isSearching"
                        class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 dark:disabled:bg-slate-700 disabled:cursor-not-allowed transition sm:hidden flex items-center justify-center min-w-[50px]">
                        <svg *ngIf="!isSearching" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <span *ngIf="isSearching">...</span>
                    </button>
                </div>
            </div>

            <!-- Selection Mode -->
            <div *ngIf="lineChoose.length > 0" class="space-y-3 animation-slide-up">
                <div class="flex justify-between items-center mb-2">
                    <h4 class="font-medium text-gray-800 dark:text-white">เลือกสมาชิก</h4>
                    <button (click)="cancelSelection()"
                        class="text-xs text-red-500 dark:text-red-400 bg-red-100 dark:bg-red-500/20 px-2 py-1 rounded-lg hover:bg-red-200 dark:hover:bg-red-500/30 hover:text-red-700 transition cursor-pointer">
                        ล้างการค้นหา
                    </button>
                </div>

                <div class="max-h-60 overflow-y-auto space-y-2 pr-1">
                    <div *ngFor="let item of lineChoose" (click)="selectMember(item)"
                        class="p-3 border rounded-lg cursor-pointer transition flex items-center gap-3"
                        [class.border-green-500]="selectedMember?.id === item.id"
                        [class.bg-green-50]="selectedMember?.id === item.id"
                        [class.dark:bg-green-900]="selectedMember?.id === item.id"
                        [class.border-gray-200]="selectedMember?.id !== item.id"
                        [class.dark:border-slate-700]="selectedMember?.id !== item.id"
                        [class.hover:bg-gray-50]="selectedMember?.id !== item.id"
                        [class.dark:hover:bg-slate-800]="selectedMember?.id !== item.id">

                        <div class="w-5 h-5 rounded-full border border-gray-300 dark:border-slate-600 flex items-center justify-center bg-white dark:bg-slate-800"
                            [class.border-green-500]="selectedMember?.id === item.id"
                            [class.dark:border-green-500]="selectedMember?.id === item.id">
                            <div *ngIf="selectedMember?.id === item.id" class="w-3 h-3 rounded-full bg-green-500"></div>
                        </div>

                        <div>
                            <p class="font-medium text-gray-800 dark:text-white">{{ item.fullName }}</p>
                            <p class="text-xs text-gray-500 dark:text-slate-400">โทร: {{ item.phone }}</p>
                            <p class="text-xs text-gray-400 dark:text-slate-500">สมัครเมื่อ: {{ item.createDate |
                                date:'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Footer -->
        <div
            class="bg-gray-50 dark:bg-slate-900/50 border-t border-gray-100 dark:border-slate-800 px-6 py-4 flex justify-end gap-3 rounded-b-2xl">
            <button (click)="closeModal()"
                class="cursor-pointer px-4 py-2 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 font-medium text-sm transition shadow-sm">
                ยกเลิก
            </button>
            <button *ngIf="lineChoose.length > 0" (click)="confirmAddMember()" [disabled]="!selectedMember"
                class="cursor-pointer px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium text-sm transition shadow-md shadow-green-200 dark:shadow-none disabled:bg-gray-300 dark:disabled:bg-slate-700 disabled:shadow-none disabled:cursor-not-allowed">
                ยืนยันการเลือก
            </button>
        </div>

    </div>
</div>